var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.662,
    height: 97.662,
    viewBox: "0 0 97.662 97.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico",
    transform: "translate(0 9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6677",
    "data-name": "Rect\\xE1ngulo 6677",
    width: 97.662,
    height: 97.662,
    transform: "translate(0 -9)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "submit_ico",
    "data-name": "submit ico",
    transform: "translate(18.808 4.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6316",
    "data-name": "Trazado 6316",
    d: "M55.673,12.568h0a2.233,2.233,0,0,0-2.335-.467L13.3,28.151a2.225,2.225,0,0,0-1.4,2.043,2.085,2.085,0,0,0,1.459,1.984l16.926,5.836L36.121,54.94A2.225,2.225,0,0,0,37.989,56.4h.117A2.225,2.225,0,0,0,40.148,55L56.2,14.9A2.085,2.085,0,0,0,55.673,12.568ZM38.747,32.587a2.114,2.114,0,0,0,0-3.035,2.185,2.185,0,0,0-3.035,0l-4.261,4.261L20.363,30.019,50.362,18,38.28,47.936,34.487,36.789Z",
    transform: "translate(-2.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6317",
    "data-name": "Trazado 6317",
    d: "M6.217,58.9l4.9-4.611a2.2,2.2,0,0,1,3.093.117h0A2.26,2.26,0,0,1,14.1,57.5l-4.9,4.611A2.2,2.2,0,0,1,6.1,61.992",
    transform: "translate(0 -17.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6318",
    "data-name": "Trazado 6318",
    d: "M21.327,72.2l-7.646,7.179a2.2,2.2,0,0,1-3.093-.117h0a2.2,2.2,0,0,1,.117-3.093l7.646-7.179a2.2,2.2,0,0,1,3.093.117h0A2.2,2.2,0,0,1,21.327,72.2Z",
    transform: "translate(-1.628 -23.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6319",
    "data-name": "Trazado 6319",
    d: "M30.488,85.892A2.2,2.2,0,0,1,30.6,82.8l4.9-4.611A2.2,2.2,0,0,1,38.6,78.3h0a2.2,2.2,0,0,1-.117,3.093l-4.9,4.611",
    transform: "translate(-9.913 -27.333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBlack);
export default __webpack_public_path__ + "static/media/send-black.cf7cae47a31949542e78a52612bcde0c.svg";
export { ForwardRef as ReactComponent };